import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `AWSDateTime` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 DateTime](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) string. In other words, this scalar type accepts datetime strings of the form `YYYY-MM-DDThh:mm:ss.SSSZ`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-01-01T00:00Z**" and "**-9999-01-01T00:00Z**" are both valid datetime strings.  The field after the two digit seconds field is a nanoseconds field. It can accept between 1 and 9 digits. So, for example, "**1970-01-01T12:00:00.2Z**", "**1970-01-01T12:00:00.277Z**" and "**1970-01-01T12:00:00.123456789Z**" are all valid datetime strings.  The seconds and nanoseconds fields are optional (the seconds field must be specified if the nanoseconds field is to be used).  The [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators) is compulsory for this scalar. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDateTime: { input: Date; output: Date; }
};

export type AddCreditInput = {
  iAmount: Scalars['Int']['input'];
  returnId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  walletId: Scalars['String']['input'];
};

export type AddressResponse = {
  __typename?: 'AddressResponse';
  addresses: Array<ExternalAddress>;
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
};

export type AdminCreateReturnDeliveryInput = {
  carrier: DeliveryDetailsCarrierInput;
  sendEmail: Scalars['Boolean']['input'];
};

export type AdminCreateReturnInput = {
  collection?: InputMaybe<TimeSlotAdminCreateReturnInput>;
  delivery?: InputMaybe<AdminCreateReturnDeliveryInput>;
  id: Scalars['ID']['input'];
  internal?: InputMaybe<AdminCreateReturnInternalInput>;
  merchantId: Scalars['ID']['input'];
  returnData: AdminCreateReturnReturnInput;
  user: AdminCreateReturnUserInput;
};

export type AdminCreateReturnInternalInput = {
  reference?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['String']['input'];
};

export type AdminCreateReturnItemsInput = {
  countryCodeOfOrigin?: InputMaybe<Scalars['String']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerUnit?: InputMaybe<PriceInput>;
  quantity: Scalars['Int']['input'];
  reason: ReturnReasons;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  weightPerUnit?: InputMaybe<WeightsInput>;
};

export type AdminCreateReturnOutboundFulfillmentInput = {
  carrier: Scalars['String']['input'];
  externalShippingDate: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
};

export type AdminCreateReturnReturnInput = {
  items: Array<AdminCreateReturnItemsInput>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderNumber: Scalars['String']['input'];
  outboundFulfillment?: InputMaybe<AdminCreateReturnOutboundFulfillmentInput>;
};

export type AdminCreateReturnUserInput = {
  address: SimpleAddressInput;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  userEmail: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminMerchantUpdateInput = {
  address?: InputMaybe<MerchantAddressInput>;
  colorScheme?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactWebsite?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<MerchantCreditInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<MerchantEmailSettingsInput>;
  labelOnlyReturnEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logistics?: InputMaybe<MerchantLogisticsInput>;
  logos?: InputMaybe<MerchantLogosInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderImportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  parcelHub?: InputMaybe<ParcelHubUpdateInput>;
  payments?: InputMaybe<MerchantPaymentInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  refundDayRange?: InputMaybe<Array<Scalars['Int']['input']>>;
  returnDeadline?: InputMaybe<Scalars['Int']['input']>;
  returnPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<MerchantState>;
  url?: InputMaybe<Scalars['String']['input']>;
  weightUnits?: InputMaybe<Weights>;
};

export type AppReturnsReason = {
  __typename?: 'AppReturnsReason';
  description: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: ReturnReasons;
  weight: Scalars['Int']['output'];
};

export type ApplyDiscountInput = {
  checkoutId: Scalars['String']['input'];
  merchantId: Scalars['ID']['input'];
};

export type BaseOrder = {
  boostEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  discount?: Maybe<Price>;
  email: Scalars['String']['output'];
  externalCreationDate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemSubTotal: Price;
  items: Array<OrderItem>;
  orderNumber: Scalars['String']['output'];
  orderTotal: Price;
  shippingTotal: Price;
};

export type Brand = {
  __typename?: 'Brand';
  colorScheme?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use logos property */
  logoUrl?: Maybe<Scalars['String']['output']>;
  logos?: Maybe<MerchantLogos>;
  merchant: Merchant;
  merchantId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<BrandOrder>;
  parents: Array<ParentTenant>;
  return?: Maybe<Return>;
  returns: ReturnsPage;
  /** @deprecated Use Brand.returns query */
  returnsD: PaginatedReturns;
  state?: Maybe<MerchantState>;
  tenantId: Scalars['String']['output'];
};


export type BrandOrderArgs = {
  orderNumber: Scalars['String']['input'];
};


export type BrandReturnArgs = {
  id: Scalars['ID']['input'];
};


export type BrandReturnsArgs = {
  page: PageInput;
};


export type BrandReturnsDArgs = {
  pagination?: InputMaybe<PaginatedInput>;
};

export type BrandOrder = BaseOrder & {
  __typename?: 'BrandOrder';
  boostEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  discount?: Maybe<Price>;
  email: Scalars['String']['output'];
  externalCreationDate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fulfillmentCarrier?: Maybe<Scalars['String']['output']>;
  fulfillmentExternalDate?: Maybe<Scalars['String']['output']>;
  fulfillmentTrackingNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemSubTotal: Price;
  items: Array<OrderItem>;
  orderNumber: Scalars['String']['output'];
  orderTotal: Price;
  /** @deprecated Use customer.address.countryCode */
  originCountryCode?: Maybe<Scalars['String']['output']>;
  shippingTotal: Price;
  userId?: Maybe<Scalars['String']['output']>;
};

export type BrandReturn = {
  __typename?: 'BrandReturn';
  accountEmail: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdByMerchant?: Maybe<Scalars['Boolean']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  hasShipment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  items: Array<ReturnItems>;
  merchant: Merchant;
  merchantId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Payment>;
  refund?: Maybe<Refund>;
  shipment?: Maybe<Shipment>;
  state: ReturnState;
  type: BrandReturnType;
  updatedAt: Scalars['AWSDateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  userProvidedOrderId?: Maybe<Scalars['String']['output']>;
};

export enum BrandReturnType {
  LabelOnly = 'LABEL_ONLY',
  Order = 'ORDER'
}

export type BrandsPage = {
  __typename?: 'BrandsPage';
  results: Array<Brand>;
  total: Scalars['Int']['output'];
};

export type C2CPaymentResult = {
  __typename?: 'C2CPaymentResult';
  customerSession?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentIntent: Scalars['String']['output'];
  total: Price;
};

export type C2CShipmentCreateInput = {
  collection?: InputMaybe<DraftPaymentCollectionInput>;
  from: C2CShipmentDeliveryDetailsFromInput;
  parcel: C2CShipmentParcelInput;
  to: C2CShipmentDeliveryDetailsToInput;
};

export type C2CShipmentDeliveryDetailsFromInput = {
  address: SimpleAddressInput;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type C2CShipmentDeliveryDetailsToInput = {
  address: SimpleAddressInput;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type C2CShipmentParcelInput = {
  dimensions: DimensionsInput;
  items: Array<PaymentsC2CParcelItemInput>;
};

export type CancelDraftPaymentResult = {
  __typename?: 'CancelDraftPaymentResult';
  canceled: Scalars['Boolean']['output'];
};

export type Carrier = {
  __typename?: 'Carrier';
  allServices: Array<CarrierService>;
  color?: Maybe<Scalars['String']['output']>;
  dropOffPointEnabled?: Maybe<Scalars['Boolean']['output']>;
  dropOffPointExternalUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  labelExpireDays?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  services: Array<CarrierService>;
  type: CarrierType;
};

export type CarrierConstraint = CountryConstraint | SizeConstraint | WeightConstraint;

export enum CarrierContractOrigin {
  Internal = 'INTERNAL',
  Whistl = 'WHISTL'
}

export type CarrierService = {
  __typename?: 'CarrierService';
  active: Scalars['Boolean']['output'];
  collectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  constraints: Array<CarrierConstraint>;
  deliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  deliveryEstimate?: Maybe<DeliveryEstimate>;
  fees?: Maybe<MerchantCarrierFees>;
  id: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
  isPrintLabelRequired?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export enum CarrierType {
  AustraliaPost = 'AUSTRALIA_POST',
  CanadaPost = 'CANADA_POST',
  Coll8 = 'COLL8',
  CollectPlus = 'COLLECT_PLUS',
  Dhl = 'DHL',
  DhlEcommerce = 'DHL_ECOMMERCE',
  Dpd = 'DPD',
  EvriCorporate = 'EVRI_CORPORATE',
  Inpost = 'INPOST',
  International = 'INTERNATIONAL',
  NzPost = 'NZ_POST',
  RoyalMail = 'ROYAL_MAIL',
  Ups = 'UPS',
  Usps = 'USPS',
  Yodel = 'YODEL'
}

export type ChannelConnection = {
  __typename?: 'ChannelConnection';
  name: SupportedChannels;
};

export enum CollectionDependencies {
  Delivery = 'DELIVERY',
  None = 'NONE',
  Same = 'SAME'
}

export type CollectionTimeSlotsResponse = {
  __typename?: 'CollectionTimeSlotsResponse';
  slots: Array<TimeSlot>;
};

export type CompleteRotateIndexInput = {
  alias?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
};

export type ConnectChannelInput = {
  config: Scalars['String']['input'];
  flowId?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
  name: SupportedChannels;
  tenantId: Scalars['String']['input'];
};

export enum ContractType {
  AustraliaPost = 'AUSTRALIA_POST',
  CanadaPost = 'CANADA_POST',
  Coll8 = 'COLL8',
  Dhl = 'DHL',
  DhlEcommerce = 'DHL_ECOMMERCE',
  Dpd = 'DPD',
  EvriCorporate = 'EVRI_CORPORATE',
  Inpost = 'INPOST',
  International = 'INTERNATIONAL',
  NzPost = 'NZ_POST',
  RoyalMail = 'ROYAL_MAIL',
  Ups = 'UPS',
  Usps = 'USPS',
  Yodel = 'YODEL'
}

export type CountryConstraint = {
  __typename?: 'CountryConstraint';
  exclude?: Maybe<Array<Scalars['String']['output']>>;
  include: Array<Scalars['String']['output']>;
  type: ServiceConstraintType;
};

export type CountryConstraintInput = {
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include: Array<Scalars['String']['input']>;
};

export type CreateBillingExportInput = {
  from: Scalars['Int']['input'];
  stripeCustomerId: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type CreateC2CPaymentInput = {
  carrier: DeliveryDetailsCarrierInput;
  merchantId: Scalars['String']['input'];
  shipment: C2CShipmentCreateInput;
};

export type CreateCarrierInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  dropOffPointEnabled: Scalars['Boolean']['input'];
  dropOffPointExternalUrl: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  labelExpireDays?: InputMaybe<Scalars['Int']['input']>;
  logo: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: CarrierType;
};

export type CreateCarrierServicesInput = {
  collectionDependency: CollectionDependencies;
  collectionEnabled: Scalars['Boolean']['input'];
  countryConstraint: CountryConstraintInput;
  deliveryEnabled: Scalars['Boolean']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalType?: InputMaybe<ExternalCarrierType>;
  internalName: Scalars['String']['input'];
  isPrintLabelRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type CreateDraftLabelReturnInput = {
  calculateUserCarbon: Scalars['Boolean']['input'];
  collection?: InputMaybe<DraftPaymentCollectionInput>;
  delivery: ReturnDraftDeliveryDetailsInput;
  id: Scalars['ID']['input'];
  items: Array<ReturnLabelOnlyItemInput>;
  merchantId: Scalars['ID']['input'];
  usersOrderId: Scalars['String']['input'];
};

export type CreateDraftReturnInput = {
  calculateUserCarbon: Scalars['Boolean']['input'];
  collection?: InputMaybe<DraftPaymentCollectionInput>;
  delivery: ReturnDraftDeliveryDetailsInput;
  id: Scalars['ID']['input'];
  items: Array<ReturnDraftItemsInput>;
  merchantId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  refund: ReturnDraftRefundInput;
  wish?: InputMaybe<WishInput>;
};

export type CreateExportCreatedAtInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExportFiltersInput = {
  createdAt?: InputMaybe<CreateExportCreatedAtInput>;
  merchants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOrgTenantInput = {
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrgUserInput = {
  configAccess: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  verifyEmail: Scalars['Boolean']['input'];
};

export type CreateRefundInput = {
  additions?: InputMaybe<Array<UpdateRefundExtrasInput>>;
  createExternalRefund?: InputMaybe<Scalars['Boolean']['input']>;
  deductions?: InputMaybe<Array<UpdateRefundExtrasInput>>;
  id: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RefundType>;
};

export type CreateRefundResult = {
  __typename?: 'CreateRefundResult';
  externalRefundCreated?: Maybe<Scalars['Boolean']['output']>;
  result: Scalars['Boolean']['output'];
};

export type CreateReportInput = {
  email: Scalars['String']['input'];
  filters?: InputMaybe<CreateExportFiltersInput>;
};

export type CreateReturnsExportInput = {
  fromEmail: Scalars['String']['input'];
  query: Scalars['String']['input'];
  toEmail: Scalars['String']['input'];
};

export type CreateWalletsExportFiltersInput = {
  merchants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateWalletsExportInput = {
  email: Scalars['String']['input'];
  filters?: InputMaybe<CreateWalletsExportFiltersInput>;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<OrderAddress>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerInput = {
  address: OrderAddressInput;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type DpdDetails = {
  dcAuthCompany: Scalars['String']['input'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  address?: Maybe<SimpleAddress>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type DeliveryDetailsCarrierInput = {
  id: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type DeliveryEstimate = {
  __typename?: 'DeliveryEstimate';
  max: Scalars['Float']['output'];
  min?: Maybe<Scalars['Float']['output']>;
  unit: DeliveryEstimateUnit;
};

export type DeliveryEstimateInput = {
  max: Scalars['Float']['input'];
  min?: InputMaybe<Scalars['Float']['input']>;
  unit: DeliveryEstimateUnit;
};

export enum DeliveryEstimateUnit {
  Days = 'DAYS',
  Hours = 'HOURS'
}

export enum DeliveryEventType {
  AddressIssue = 'ADDRESS_ISSUE',
  AtHub = 'AT_HUB',
  AwaitingCustomerCollection = 'AWAITING_CUSTOMER_COLLECTION',
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Collected = 'COLLECTED',
  Damaged = 'DAMAGED',
  Delivered = 'DELIVERED',
  FailedAttempt = 'FAILED_ATTEMPT',
  InTransit = 'IN_TRANSIT',
  Missing = 'MISSING',
  OnHold = 'ON_HOLD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Packing = 'PACKING',
  ReturnedToSender = 'RETURNED_TO_SENDER',
  TrackingExpired = 'TRACKING_EXPIRED'
}

export type DeliveryEvents = {
  __typename?: 'DeliveryEvents';
  description?: Maybe<Scalars['String']['output']>;
  eventDate: Scalars['AWSDateTime']['output'];
  type: DeliveryEventType;
};

export enum DeliveryState {
  AwaitingBooking = 'AWAITING_BOOKING',
  AwaitingLabel = 'AWAITING_LABEL',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Fail = 'FAIL',
  Ongoing = 'ONGOING',
  Ready = 'READY'
}

export type DhlEcommAuthDetails = {
  apiKey: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  collectionAccount?: InputMaybe<Scalars['String']['input']>;
  partnerCode?: InputMaybe<Scalars['String']['input']>;
  pickupAccount: Scalars['String']['input'];
};

export type DimensionsInput = {
  height: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  unit: Sizes;
  width: Scalars['Float']['input'];
};

export type DraftItemRefundBreakdown = {
  __typename?: 'DraftItemRefundBreakdown';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  total?: Maybe<Price>;
};

export type DraftPayment = {
  __typename?: 'DraftPayment';
  cost?: Maybe<DraftPaymentCost>;
  deductions: Array<DraftPaymentDeductions>;
  expectedRefund?: Maybe<Price>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<DraftPaymentFees>;
  feesV2?: Maybe<DraftPaymentFeesV2>;
  itemExchangeBreakdown?: Maybe<Array<DraftItemRefundBreakdown>>;
  itemExchangeTotal?: Maybe<Price>;
  itemRefundBreakdown?: Maybe<Array<DraftItemRefundBreakdown>>;
  itemRefundTotal?: Maybe<Price>;
  refundAdditions?: Maybe<Array<DraftPaymentRefundAdditions>>;
  refundType: RefundType;
  state: DraftPaymentState;
};

export type DraftPaymentCollectionInput = {
  timeSlot: DraftPaymentCollectionTimeSlotInput;
};

export type DraftPaymentCollectionTimeSlotInput = {
  date: Scalars['String']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
};

export type DraftPaymentCost = {
  __typename?: 'DraftPaymentCost';
  handling: Price;
  total: Price;
  vat: Price;
};

export type DraftPaymentDeductions = {
  __typename?: 'DraftPaymentDeductions';
  total: Price;
  type: PaymentDeductionType;
};

export type DraftPaymentFees = {
  __typename?: 'DraftPaymentFees';
  handling?: Maybe<Price>;
  total?: Maybe<Price>;
  vat?: Maybe<Price>;
  waive: PaymentWaiveStatus;
};

export type DraftPaymentFeesV2 = {
  __typename?: 'DraftPaymentFeesV2';
  items: Array<DraftPaymentFeesV2Item>;
  total: Price;
  vat: Price;
};

export type DraftPaymentFeesV2Item = {
  __typename?: 'DraftPaymentFeesV2Item';
  amount: Price;
  type: FeesV2Type;
  waive: PaymentWaiveStatus;
};

export type DraftPaymentRefundAdditions = {
  __typename?: 'DraftPaymentRefundAdditions';
  total: Price;
  type: PaymentAdditionsType;
};

export enum DraftPaymentState {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type DropoffPoint = {
  __typename?: 'DropoffPoint';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  carrierType: CarrierType;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  openingHours?: Maybe<Array<Maybe<OpeningHours>>>;
  postcode: Scalars['String']['output'];
};

export type EvaluateRefundInput = {
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  evaluations?: InputMaybe<Array<EvaluationsInput>>;
  id: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type EvaluationAccepted = {
  __typename?: 'EvaluationAccepted';
  type: RefundItemEvaluationStatus;
};

export type EvaluationRefused = {
  __typename?: 'EvaluationRefused';
  reason: RefundItemRejectedReasons;
  type: RefundItemEvaluationStatus;
};

export type EvaluationsInput = {
  grade?: InputMaybe<Scalars['Int']['input']>;
  index: Scalars['Int']['input'];
  itemId: Scalars['ID']['input'];
  reason?: InputMaybe<RefundItemRejectedReasons>;
  status?: InputMaybe<RefundItemEvaluationStatus>;
};

export type EvriAuthDetails = {
  apiKey: Scalars['String']['input'];
  authClientId: Scalars['String']['input'];
  authClientSecret: Scalars['String']['input'];
  childId?: InputMaybe<Scalars['String']['input']>;
  childName?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  dcAuthCompany: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type Exchange = {
  __typename?: 'Exchange';
  products: Array<ExchangeProducts>;
  type: WishType;
};

export type ExchangeProducts = {
  __typename?: 'ExchangeProducts';
  externalProductId: Scalars['String']['output'];
  externalVariantId: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Price;
  quantity: Scalars['Int']['output'];
  selectedOptions?: Maybe<Array<SelectedOption>>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type Exchanges = {
  __typename?: 'Exchanges';
  externalOrderId: Scalars['String']['output'];
};

export type ExternalAddress = {
  __typename?: 'ExternalAddress';
  building_name: Scalars['String']['output'];
  building_number: Scalars['String']['output'];
  country: Scalars['String']['output'];
  county: Scalars['String']['output'];
  district: Scalars['String']['output'];
  formatted_address: Array<Scalars['String']['output']>;
  line_1: Scalars['String']['output'];
  line_2: Scalars['String']['output'];
  line_3: Scalars['String']['output'];
  line_4: Scalars['String']['output'];
  locality: Scalars['String']['output'];
  sub_building_name: Scalars['String']['output'];
  sub_building_number: Scalars['String']['output'];
  thoroughfare: Scalars['String']['output'];
  town_or_city: Scalars['String']['output'];
};

export enum ExternalCarrierType {
  C2B = 'C2B',
  C2C = 'C2C'
}

export enum ExtrasDiscrepancyType {
  Boost = 'BOOST',
  Discrepancy = 'DISCREPANCY',
  Exchange = 'EXCHANGE',
  Shipping = 'SHIPPING',
  Unknown = 'UNKNOWN'
}

export enum FeesV2Type {
  ExchangeOverage = 'EXCHANGE_OVERAGE',
  PaymentProcessing = 'PAYMENT_PROCESSING',
  ReturnCarriage = 'RETURN_CARRIAGE'
}

export enum FinanceStatus {
  Accepted = 'ACCEPTED',
  Incomplete = 'INCOMPLETE',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED'
}

export type FinanceUnit = {
  __typename?: 'FinanceUnit';
  refund?: Maybe<Price>;
};

export type FinanceUnitInput = {
  refund: PriceInput;
};

export type GetLinkedSourcesInput = {
  flowId?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
};

export type GetLinkedSourcesResponse = {
  __typename?: 'GetLinkedSourcesResponse';
  merchantId: Scalars['String']['output'];
  sources?: Maybe<Array<SupportedChannels>>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type InPostAuthDetails = {
  bearer: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export enum IndexType {
  Brands = 'BRANDS',
  Returns = 'RETURNS'
}

export type IngestedOrder = {
  __typename?: 'IngestedOrder';
  boostEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  discount?: Maybe<Price>;
  externalCreationDate?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  itemSubTotal: Price;
  items: Array<IngestedOrderItem>;
  orderNumber: Scalars['String']['output'];
  orderTotal: Price;
  /** @deprecated Use customer.address.countryCode */
  originCountryCode?: Maybe<Scalars['String']['output']>;
  shippingTotal: Price;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type IngestedOrderItem = {
  __typename?: 'IngestedOrderItem';
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Price>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Price;
  quantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type InternationalDetails = {
  proCarrierApiKey: Scalars['String']['input'];
};

export type Label = {
  __typename?: 'Label';
  type: LabelType;
  url: Scalars['String']['output'];
};

export enum LabelType {
  Paper = 'PAPER',
  Paperless = 'PAPERLESS'
}

export type Merchant = {
  __typename?: 'Merchant';
  address?: Maybe<MerchantAddress>;
  appReturnsReasons: Array<AppReturnsReason>;
  assets: Array<MerchantAssetUpload>;
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<MerchantBilling>;
  carriers?: Maybe<Array<Carrier>>;
  colorScheme?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactWebsite?: Maybe<Scalars['String']['output']>;
  /** @deprecated only here to support Shopify, use carriers */
  contracts?: Maybe<Array<Carrier>>;
  credit?: Maybe<MerchantCredit>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<MerchantEmailSettings>;
  estimatedShippingTime?: Maybe<Scalars['Int']['output']>;
  exchanges?: Maybe<MerchantExchanges>;
  exclusions?: Maybe<MerchantExclusions>;
  externalBillingReference?: Maybe<Scalars['String']['output']>;
  externalShopName?: Maybe<Scalars['String']['output']>;
  flexBrandId?: Maybe<Scalars['String']['output']>;
  gradingType?: Maybe<MerchantGradingType>;
  id: Scalars['ID']['output'];
  labelNamePreference?: Maybe<ShippingLabelName>;
  labelOnlyReturnEnabled?: Maybe<Scalars['Boolean']['output']>;
  logos?: Maybe<MerchantLogos>;
  managementSystem?: Maybe<MerchantManagementSystems>;
  manualReferenceCopy?: Maybe<Scalars['String']['output']>;
  mintsoft?: Maybe<MintsoftIntegration>;
  name: Scalars['String']['output'];
  orderImportEnabled?: Maybe<Scalars['Boolean']['output']>;
  ordersConfig?: Maybe<MerchantOrders>;
  payments?: Maybe<MerchantPayment>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  portalActive: Scalars['Boolean']['output'];
  refundDayRange?: Maybe<Array<Scalars['Int']['output']>>;
  refundsConfig?: Maybe<MerchantRefunds>;
  returnDeadline?: Maybe<Scalars['Int']['output']>;
  returnPolicyUrl?: Maybe<Scalars['String']['output']>;
  returnsReasons: Array<MerchantReturnsReason>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<MerchantState>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
  weightUnits: Weights;
};


export type MerchantAssetsArgs = {
  fileNames: Array<Scalars['String']['input']>;
};

export type MerchantAddress = {
  __typename?: 'MerchantAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  postCode: Scalars['String']['output'];
};

export type MerchantAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  postCode: Scalars['String']['input'];
};

export type MerchantAssetUpload = {
  __typename?: 'MerchantAssetUpload';
  fileName: Scalars['String']['output'];
  target: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type MerchantBilling = {
  __typename?: 'MerchantBilling';
  internationalStripeBillingId?: Maybe<Scalars['String']['output']>;
  stripeBillingCustomerId?: Maybe<Scalars['String']['output']>;
  stripeBillingCustomerIdSecondary?: Maybe<Scalars['String']['output']>;
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
};

export type MerchantBillingUpdateInput = {
  internationalStripeBillingId?: InputMaybe<Scalars['String']['input']>;
  stripeBillingCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeBillingCustomerIdSecondary?: InputMaybe<Scalars['String']['input']>;
  stripeConnectAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantCarrierAddInput = {
  carrierId: Scalars['ID']['input'];
  dhlEcommDetails?: InputMaybe<DhlEcommAuthDetails>;
  dpdDetails?: InputMaybe<DpdDetails>;
  evriDetails?: InputMaybe<EvriAuthDetails>;
  inPostDetails?: InputMaybe<InPostAuthDetails>;
  internationalDetails?: InputMaybe<InternationalDetails>;
  origin: CarrierContractOrigin;
  royalMailDetails?: InputMaybe<RoyalMailDetails>;
  type: ContractType;
  yodelDetails?: InputMaybe<YodelAuthDetails>;
};

export type MerchantCarrierConfigServicesInput = {
  active: Scalars['Boolean']['input'];
  fee?: InputMaybe<PriceInput>;
  id: Scalars['String']['input'];
};

export type MerchantCarrierContractEditInput = {
  dhlEcommDetails?: InputMaybe<DhlEcommAuthDetails>;
  dpdDetails?: InputMaybe<DpdDetails>;
  evriDetails?: InputMaybe<EvriAuthDetails>;
  inPostDetails?: InputMaybe<InPostAuthDetails>;
  internationalDetails?: InputMaybe<InternationalDetails>;
  origin: CarrierContractOrigin;
  royalMailDetails?: InputMaybe<RoyalMailDetails>;
  type: ContractType;
  yodelDetails?: InputMaybe<YodelAuthDetails>;
};

export type MerchantCarrierCredential = {
  __typename?: 'MerchantCarrierCredential';
  name?: Maybe<Scalars['String']['output']>;
};

export type MerchantCarrierFees = {
  __typename?: 'MerchantCarrierFees';
  price: Price;
  type: MerchantCarrierFeesType;
};

export enum MerchantCarrierFeesType {
  CarrierService = 'CARRIER_SERVICE'
}

export type MerchantCarrierUpdateInput = {
  active: Scalars['Boolean']['input'];
  carrierId: Scalars['String']['input'];
  services?: InputMaybe<Array<MerchantCarrierConfigServicesInput>>;
};

export type MerchantCreateInput = {
  currency: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  managementSystem: MerchantManagementSystems;
  name: Scalars['String']['input'];
  parentTenant?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  weightUnits: Weights;
};

export type MerchantCredit = {
  __typename?: 'MerchantCredit';
  boostEnabled?: Maybe<Scalars['Boolean']['output']>;
  boostPercentage?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  flexEnabled?: Maybe<Scalars['Boolean']['output']>;
  maximumBoost?: Maybe<Scalars['Float']['output']>;
};

export type MerchantCreditInput = {
  boostEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  boostPercentage?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  flexEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maximumBoost?: InputMaybe<Scalars['Float']['input']>;
};

export type MerchantEmailSettings = {
  __typename?: 'MerchantEmailSettings';
  emailLabel: Scalars['Boolean']['output'];
};

export type MerchantEmailSettingsInput = {
  emailLabel: Scalars['Boolean']['input'];
};

export type MerchantExchanges = {
  __typename?: 'MerchantExchanges';
  disabledReason?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isInternationalEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MerchantExchangesUpdateInput = {
  enable: Scalars['Boolean']['input'];
  enableInternational: Scalars['Boolean']['input'];
};

export type MerchantExclusions = {
  __typename?: 'MerchantExclusions';
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type MerchantExclusionsInput = {
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export enum MerchantGradingType {
  Binary = 'BINARY',
  Multiple = 'MULTIPLE'
}

export type MerchantLogisticsContractInput = {
  activeServices?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierId: Scalars['String']['input'];
  contractActive: Scalars['Boolean']['input'];
};

export type MerchantLogisticsInput = {
  contracts?: InputMaybe<Array<MerchantLogisticsContractInput>>;
};

export type MerchantLogos = {
  __typename?: 'MerchantLogos';
  long?: Maybe<Scalars['String']['output']>;
  square?: Maybe<Scalars['String']['output']>;
};

export type MerchantLogosInput = {
  long?: InputMaybe<Scalars['String']['input']>;
  square?: InputMaybe<Scalars['String']['input']>;
};

export enum MerchantManagementSystems {
  Custom = 'CUSTOM',
  Shopify = 'SHOPIFY'
}

export type MerchantOrders = {
  __typename?: 'MerchantOrders';
  waitForOrderFulfilment: Scalars['Boolean']['output'];
};

export type MerchantOrdersInput = {
  waitForOrderFulfilment: Scalars['Boolean']['input'];
};

export type MerchantPayment = {
  __typename?: 'MerchantPayment';
  costsPaymentType?: Maybe<ReturnCostsPaymentType>;
  waivedReasons?: Maybe<Array<WaivedReasons>>;
};

export type MerchantPaymentFeesInput = {
  carrierId: Scalars['String']['input'];
  price: PriceInput;
  serviceId: Scalars['String']['input'];
};

export type MerchantPaymentInput = {
  costsPaymentType?: InputMaybe<ReturnCostsPaymentType>;
  fees?: InputMaybe<Array<MerchantPaymentFeesInput>>;
  waive?: InputMaybe<Array<PaymentWaivingInput>>;
};

export type MerchantRefunds = {
  __typename?: 'MerchantRefunds';
  isExternalRefundsEnabled: Scalars['Boolean']['output'];
};

export type MerchantRefundsInput = {
  isExternalRefundsEnabled: Scalars['Boolean']['input'];
};

export type MerchantReturnsReason = {
  __typename?: 'MerchantReturnsReason';
  description: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: ReturnReasons;
  waive: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type MerchantReturnsReasonUpdateInput = {
  description: Scalars['String']['input'];
  editable: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  waive: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export enum MerchantState {
  Inactive = 'INACTIVE',
  Live = 'LIVE',
  Onboarding = 'ONBOARDING',
  Ready = 'READY'
}

export type MerchantUpdateInput = {
  address?: InputMaybe<MerchantAddressInput>;
  colorScheme?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactWebsite?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<MerchantEmailSettingsInput>;
  estimatedShippingTime?: InputMaybe<Scalars['Int']['input']>;
  exclusions?: InputMaybe<MerchantExclusionsInput>;
  labelOnlyReturnEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logistics?: InputMaybe<MerchantLogisticsInput>;
  logos?: InputMaybe<MerchantLogosInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderImportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<MerchantPaymentInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  refundDayRange?: InputMaybe<Array<Scalars['Int']['input']>>;
  returnDeadline?: InputMaybe<Scalars['Int']['input']>;
  returnPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  weightUnits?: InputMaybe<Weights>;
};

export type MintsoftExternalReturnsReason = {
  __typename?: 'MintsoftExternalReturnsReason';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  stockAction: Scalars['String']['output'];
};

export type MintsoftExternals = {
  __typename?: 'MintsoftExternals';
  returnsReasons: Array<MintsoftExternalReturnsReason>;
};

export type MintsoftIntegration = {
  __typename?: 'MintsoftIntegration';
  enabled: Scalars['Boolean']['output'];
  external?: Maybe<MintsoftExternals>;
  lazyOrderImportEnabled: Scalars['Boolean']['output'];
  returnsReasons: Array<MintsoftIntegrationReasonsMap>;
};

export type MintsoftIntegrationReasonsMap = {
  __typename?: 'MintsoftIntegrationReasonsMap';
  internalId: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  mintsoftId: Scalars['Int']['output'];
};

export type MintsoftMerchantIntegrationCreateInput = {
  apiKey: Scalars['String']['input'];
  lazyOrderImportEnable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MintsoftMerchantIntegrationUpdateInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  lazyOrderImportEnable?: InputMaybe<Scalars['Boolean']['input']>;
  returnsReasons?: InputMaybe<Array<MintsoftReturnsReasonInput>>;
};

export type MintsoftReturnsReasonInput = {
  internalId: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  mintsoftId: Scalars['Int']['input'];
};

export type MoveOrgBrandInput = {
  brandId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};

export type MoveOrgTenantInput = {
  parentId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  applyDiscount: Result;
  assignIngestedOrder?: Maybe<Order>;
  cancelDraftPayment: CancelDraftPaymentResult;
  carrierCreate: Carrier;
  carrierServiceCreate: CarrierService;
  carrierServiceUpdate: CarrierService;
  carrierUpdate?: Maybe<Carrier>;
  connectChannel: ChannelConnection;
  createBillingExport: Result;
  createDraftLabelReturn: Result;
  createDraftReturn: Result;
  createExternalDraftOrder: Result;
  createOrgTenant: Result;
  createOrgUser: Result;
  createRefund?: Maybe<RefundTransaction>;
  createReturnShipment: Shipment;
  createReturnsExport: Result;
  createUnitsExport: Result;
  createWalletsExport: Result;
  emailReturn: Result;
  evaluateRefundItems: Refund;
  eventCreated: ServerEvent;
  evictOrgCache: Result;
  initiatePayment: PaymentInitiationResult;
  merchantBillingUpdate: Result;
  merchantCarrierAdd: Merchant;
  merchantCarrierContractEdit: MerchantCarrierCredential;
  merchantCarriersUpdate: Merchant;
  merchantCreate: Merchant;
  merchantExchangesUpdate: Result;
  merchantReturnsReasonEdit: Array<MerchantReturnsReason>;
  merchantToggleLiveStatus: Merchant;
  merchantUpdate: Merchant;
  mintsoftCreate: MintsoftIntegration;
  mintsoftUpdate: MintsoftIntegration;
  moveOrgTenant: Result;
  paymentsC2CShipmentCreate: C2CPaymentResult;
  refundPayment: Result;
  rejectRefund?: Maybe<Refund>;
  searchCompleteRotateIndex: Result;
  searchRotateIndex: OpenSearchRotateIndexResponse;
  testWalletAddCredit?: Maybe<Wallet>;
  updateProfile: User;
  updateUnits?: Maybe<Result>;
};


export type MutationApplyDiscountArgs = {
  data: ApplyDiscountInput;
};


export type MutationAssignIngestedOrderArgs = {
  ingestedOrderId: Scalars['ID']['input'];
};


export type MutationCancelDraftPaymentArgs = {
  draftId: Scalars['ID']['input'];
};


export type MutationCarrierCreateArgs = {
  data: CreateCarrierInput;
};


export type MutationCarrierServiceCreateArgs = {
  carrierId: Scalars['ID']['input'];
  data: CreateCarrierServicesInput;
};


export type MutationCarrierServiceUpdateArgs = {
  carrierId: Scalars['ID']['input'];
  data: UpdateCarrierServicesInput;
};


export type MutationCarrierUpdateArgs = {
  data: UpdateCarrierInput;
  id: Scalars['String']['input'];
};


export type MutationConnectChannelArgs = {
  data: ConnectChannelInput;
};


export type MutationCreateBillingExportArgs = {
  data: CreateBillingExportInput;
};


export type MutationCreateDraftLabelReturnArgs = {
  data: CreateDraftLabelReturnInput;
};


export type MutationCreateDraftReturnArgs = {
  data: CreateDraftReturnInput;
};


export type MutationCreateExternalDraftOrderArgs = {
  customer: CustomerInput;
  items: Array<OrderItemInput>;
  merchantId: Scalars['ID']['input'];
  returnId: Scalars['ID']['input'];
  returnName: Scalars['String']['input'];
};


export type MutationCreateOrgTenantArgs = {
  data: CreateOrgTenantInput;
};


export type MutationCreateOrgUserArgs = {
  data: CreateOrgUserInput;
};


export type MutationCreateRefundArgs = {
  data: CreateRefundInput;
};


export type MutationCreateReturnShipmentArgs = {
  data: AdminCreateReturnInput;
};


export type MutationCreateReturnsExportArgs = {
  data: CreateReportInput;
};


export type MutationCreateUnitsExportArgs = {
  data: CreateReportInput;
};


export type MutationCreateWalletsExportArgs = {
  data: CreateWalletsExportInput;
};


export type MutationEmailReturnArgs = {
  returnId: Scalars['ID']['input'];
};


export type MutationEvaluateRefundItemsArgs = {
  data: EvaluateRefundInput;
};


export type MutationEventCreatedArgs = {
  event: ServerEventInput;
};


export type MutationInitiatePaymentArgs = {
  acceptedCarbonCost: Scalars['Boolean']['input'];
  draftId: Scalars['ID']['input'];
};


export type MutationMerchantBillingUpdateArgs = {
  data: MerchantBillingUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationMerchantCarrierAddArgs = {
  carriers: Array<MerchantCarrierAddInput>;
  id: Scalars['ID']['input'];
};


export type MutationMerchantCarrierContractEditArgs = {
  carrierId: Scalars['ID']['input'];
  credentials: MerchantCarrierContractEditInput;
  id: Scalars['ID']['input'];
};


export type MutationMerchantCarriersUpdateArgs = {
  carriers: Array<InputMaybe<MerchantCarrierUpdateInput>>;
  costsPaymentType?: InputMaybe<ReturnCostsPaymentType>;
  id: Scalars['ID']['input'];
};


export type MutationMerchantCreateArgs = {
  data: MerchantCreateInput;
};


export type MutationMerchantExchangesUpdateArgs = {
  data: MerchantExchangesUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationMerchantReturnsReasonEditArgs = {
  data: Array<MerchantReturnsReasonUpdateInput>;
  id: Scalars['ID']['input'];
};


export type MutationMerchantToggleLiveStatusArgs = {
  id: Scalars['ID']['input'];
  isLive: Scalars['Boolean']['input'];
};


export type MutationMerchantUpdateArgs = {
  data: UpdateMerchantV2Input;
  id: Scalars['ID']['input'];
};


export type MutationMintsoftCreateArgs = {
  data: MintsoftMerchantIntegrationCreateInput;
  merchantId: Scalars['ID']['input'];
};


export type MutationMintsoftUpdateArgs = {
  data: MintsoftMerchantIntegrationUpdateInput;
  merchantId: Scalars['ID']['input'];
};


export type MutationMoveOrgTenantArgs = {
  data: MoveOrgTenantInput;
};


export type MutationPaymentsC2CShipmentCreateArgs = {
  data: CreateC2CPaymentInput;
};


export type MutationRefundPaymentArgs = {
  amount: PriceInput;
  returnId: Scalars['ID']['input'];
};


export type MutationRejectRefundArgs = {
  data: RejectRefundInput;
};


export type MutationSearchCompleteRotateIndexArgs = {
  data: CompleteRotateIndexInput;
};


export type MutationSearchRotateIndexArgs = {
  data: OpenSearchRotateIndexInput;
};


export type MutationTestWalletAddCreditArgs = {
  data: AddCreditInput;
};


export type MutationUpdateProfileArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateUnitsArgs = {
  data: RefundUnitsInput;
};

export type OpenSearchRotateIndexInput = {
  id: Scalars['String']['input'];
  reIndex?: InputMaybe<Scalars['Boolean']['input']>;
  type: IndexType;
};

export type OpenSearchRotateIndexResponse = {
  __typename?: 'OpenSearchRotateIndexResponse';
  result: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
};

export type OpenSearchTask = {
  __typename?: 'OpenSearchTask';
  completed: Scalars['Boolean']['output'];
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  closeTime: Scalars['String']['output'];
  dayOfWeek: Scalars['String']['output'];
  openTime: Scalars['String']['output'];
};

export type Option = {
  __typename?: 'Option';
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  values: Array<Scalars['String']['output']>;
};

export type Order = BaseOrder & {
  __typename?: 'Order';
  boostEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  discount?: Maybe<Price>;
  email: Scalars['String']['output'];
  externalCreationDate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fulfillmentCarrier?: Maybe<Scalars['String']['output']>;
  fulfillmentExternalDate?: Maybe<Scalars['String']['output']>;
  fulfillmentTrackingNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isIneligible?: Maybe<Scalars['Boolean']['output']>;
  itemSubTotal: Price;
  items: Array<OrderItem>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  merchant: Merchant;
  orderNumber: Scalars['String']['output'];
  orderTotal: Price;
  /** @deprecated Use customer.address.countryCode */
  originCountryCode?: Maybe<Scalars['String']['output']>;
  shippingTotal: Price;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  postCode: Scalars['String']['output'];
  provinceCode?: Maybe<Scalars['String']['output']>;
};

export type OrderAddressInput = {
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  postCode: Scalars['String']['input'];
  provinceCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  countryCodeOfOrigin?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use discountPerUnit */
  discount?: Maybe<Price>;
  discountPerUnit?: Maybe<Price>;
  discountTotal?: Maybe<Price>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalVariantId?: Maybe<Scalars['String']['output']>;
  hsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isIneligible?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidPerUnit?: Maybe<Price>;
  paidTotal?: Maybe<Price>;
  /** @deprecated Use pricePerUnit */
  price?: Maybe<Price>;
  pricePerUnit?: Maybe<Price>;
  priceTotal?: Maybe<Price>;
  quantity: Scalars['Int']['output'];
  returnedQuantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  weightPerUnit?: Maybe<Weight>;
};

export type OrderItemInput = {
  externalVariantId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type Org = {
  __typename?: 'Org';
  brand?: Maybe<Brand>;
  brands?: Maybe<BrandsPage>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  returns: ReturnsPage;
};


export type OrgBrandArgs = {
  id: Scalars['ID']['input'];
};


export type OrgBrandsArgs = {
  filters?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page: PageInput;
};


export type OrgReturnsArgs = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filters?: InputMaybe<Scalars['String']['input']>;
  page: PageInput;
  sorts?: InputMaybe<Scalars['String']['input']>;
};

export enum PudoNetworkType {
  CollectPlus = 'COLLECT_PLUS'
}

export type PageInput = {
  from: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginatedInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type PaginatedOrders = {
  __typename?: 'PaginatedOrders';
  nextToken?: Maybe<Scalars['String']['output']>;
  results: Array<Order>;
};

export type PaginatedProductsResponse = {
  __typename?: 'PaginatedProductsResponse';
  nextToken?: Maybe<Scalars['String']['output']>;
  results: Array<Product>;
};

export type PaginatedReturns = {
  __typename?: 'PaginatedReturns';
  nextToken?: Maybe<Scalars['String']['output']>;
  results: Array<Return>;
};

export type PaginatedTransactions = {
  __typename?: 'PaginatedTransactions';
  nextToken?: Maybe<Scalars['String']['output']>;
  results: Array<Transaction>;
};

export type PaginatedWallets = {
  __typename?: 'PaginatedWallets';
  nextToken?: Maybe<Scalars['String']['output']>;
  results: Array<Wallet>;
};

export type ParcelHubContractDetailsInput = {
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ParcelHubOverridesInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<ParcelHubOverridesServicesInput>>;
};

export type ParcelHubOverridesServicesInput = {
  id: Scalars['String']['input'];
  lId: Scalars['String']['input'];
};

export type ParcelHubServiceConfig = {
  hcServiceId?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
};

export type ParcelHubUpdateInput = {
  SAPId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  overrides?: InputMaybe<ParcelHubOverridesInput>;
};

export type ParentTenant = {
  __typename?: 'ParentTenant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  failureReason?: Maybe<Scalars['String']['output']>;
  /** @deprecated useless, use what's on the return */
  meta?: Maybe<PaymentMeta>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  refunds?: Maybe<PaymentRefund>;
  state: PaymentStatus;
  total?: Maybe<Price>;
};

export enum PaymentAdditionsType {
  CreditBoost = 'CREDIT_BOOST'
}

export type PaymentBreakdown = {
  __typename?: 'PaymentBreakdown';
  handling?: Maybe<Price>;
  vat?: Maybe<Price>;
};

export enum PaymentDeductionType {
  DeductRefund = 'DEDUCT_REFUND',
  Exchange = 'EXCHANGE',
  ReturnCarriage = 'RETURN_CARRIAGE'
}

export type PaymentInitiationResult = {
  __typename?: 'PaymentInitiationResult';
  free: Scalars['Boolean']['output'];
  intentData?: Maybe<PaymentIntent>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  paymentIntent: Scalars['String']['output'];
};

export type PaymentMeta = {
  __typename?: 'PaymentMeta';
  cost?: Maybe<DraftPaymentCost>;
  deductions: Array<DraftPaymentDeductions>;
  expectedRefund?: Maybe<Price>;
  fees?: Maybe<DraftPaymentFees>;
  feesV2?: Maybe<DraftPaymentFeesV2>;
};

export type PaymentRefund = {
  __typename?: 'PaymentRefund';
  entries: Array<PaymentRefundEntry>;
  total: Price;
};

export type PaymentRefundEntry = {
  __typename?: 'PaymentRefundEntry';
  amount: Price;
  createdAt: Scalars['AWSDateTime']['output'];
  externalPaymentIntentId: Scalars['String']['output'];
  externalRefundId: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export enum PaymentState {
  Complete = 'COMPLETE',
  Pending = 'PENDING'
}

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type PaymentWaiveStatus = {
  __typename?: 'PaymentWaiveStatus';
  reason?: Maybe<ReturnReasons>;
  status: WaiveStatus;
};

export type PaymentWaivingInput = {
  quantity: Scalars['Int']['input'];
  reason: ReturnReasons;
};

export type PaymentsC2CParcelItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  price: PriceInput;
  quantity: Scalars['Int']['input'];
  weight: WeightsInput;
};

export type PostcodeResponse = {
  __typename?: 'PostcodeResponse';
  building_name: Scalars['String']['output'];
  building_number: Scalars['String']['output'];
  country: Scalars['String']['output'];
  county: Scalars['String']['output'];
  district: Scalars['String']['output'];
  formatted_address: Array<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  line_1: Scalars['String']['output'];
  line_2: Scalars['String']['output'];
  line_3: Scalars['String']['output'];
  line_4: Scalars['String']['output'];
  locality: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  postcode: Scalars['String']['output'];
  residential: Scalars['Boolean']['output'];
  sub_building_name: Scalars['String']['output'];
  sub_building_number: Scalars['String']['output'];
  thoroughfare: Scalars['String']['output'];
  town_or_city: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PriceInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type Product = {
  __typename?: 'Product';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  externalId: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isOutOfStock: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Price;
};

export type ProductWithVariants = {
  __typename?: 'ProductWithVariants';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  isExchangeable: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Option>>;
  variants: Array<Variant>;
};

export type PudoNetwork = {
  __typename?: 'PudoNetwork';
  color?: Maybe<Scalars['String']['output']>;
  dropOffPointEnabled?: Maybe<Scalars['Boolean']['output']>;
  dropOffPointExternalUrl: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<PudoNetworkType>;
};

export type QaUnit = {
  __typename?: 'QAUnit';
  grade: Scalars['Int']['output'];
  status?: Maybe<RefundItemStatus>;
};

export type Query = {
  __typename?: 'Query';
  address: AddressResponse;
  brand?: Maybe<Brand>;
  brands?: Maybe<BrandsPage>;
  carriers?: Maybe<Array<Carrier>>;
  collectionTimeSlots: CollectionTimeSlotsResponse;
  dropoffPoints?: Maybe<Array<DropoffPoint>>;
  getLinkedSources: GetLinkedSourcesResponse;
  ingested?: Maybe<Array<IngestedOrder>>;
  me?: Maybe<User>;
  merchant?: Maybe<Merchant>;
  merchantReturn?: Maybe<Return>;
  merchantReturns: PaginatedReturns;
  merchantSlugAvailable: Result;
  order?: Maybe<Order>;
  orders: PaginatedOrders;
  org?: Maybe<Org>;
  payment?: Maybe<DraftPayment>;
  postcode: PostcodeResponse;
  product?: Maybe<ProductWithVariants>;
  products: PaginatedProductsResponse;
  return?: Maybe<Return>;
  returns: PaginatedReturns;
  searchTask?: Maybe<OpenSearchTask>;
  shipments: ShipmentsPage;
  walletTransactions: PaginatedTransactions;
  wallets?: Maybe<PaginatedWallets>;
};


export type QueryAddressArgs = {
  postcode: Scalars['String']['input'];
};


export type QueryBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandsArgs = {
  page: PageInput;
};


export type QueryCollectionTimeSlotsArgs = {
  carrierId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
};


export type QueryDropoffPointsArgs = {
  carriers: Array<InputMaybe<Scalars['String']['input']>>;
  merchantId: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
};


export type QueryGetLinkedSourcesArgs = {
  data: GetLinkedSourcesInput;
};


export type QueryIngestedArgs = {
  merchantId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
};


export type QueryMerchantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantReturnArgs = {
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  returnId: Scalars['ID']['input'];
};


export type QueryMerchantReturnsArgs = {
  pagination?: InputMaybe<PaginatedInput>;
};


export type QueryMerchantSlugAvailableArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrdersArgs = {
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginatedInput>;
};


export type QueryPaymentArgs = {
  draftId: Scalars['ID']['input'];
};


export type QueryPostcodeArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
  merchantId: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  merchantId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginatedInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReturnArgs = {
  id: Scalars['ID']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReturnsArgs = {
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginatedInput>;
};


export type QuerySearchTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShipmentsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryWalletTransactionsArgs = {
  pagination?: InputMaybe<PaginatedInput>;
  walletId: Scalars['ID']['input'];
};


export type QueryWalletsArgs = {
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginatedInput>;
};

export type Refund = {
  __typename?: 'Refund';
  additions?: Maybe<Array<RefundReturnExtra>>;
  aggregateRefunded?: Maybe<Price>;
  appliedBoostPercentage?: Maybe<Scalars['Int']['output']>;
  deductions?: Maybe<Array<RefundReturnExtra>>;
  evaluation: RefundEvaluation;
  evaluationStatus: RefundEvaluationStatus;
  expectedRefundDeduction?: Maybe<Price>;
  expectedRefundTotal?: Maybe<Price>;
  expectedRefundType: RefundType;
  financeStatus: FinanceStatus;
  id: Scalars['ID']['output'];
  items: Array<RefundItem>;
  note?: Maybe<Scalars['String']['output']>;
  processing: Scalars['Boolean']['output'];
  refunded?: Maybe<Price>;
  state: RefundStatusV2;
  transactions: Array<RefundTransaction>;
  units: Array<RefundUnit>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RefundEvaluation = {
  __typename?: 'RefundEvaluation';
  note?: Maybe<Scalars['String']['output']>;
  status: RefundEvaluationStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum RefundEvaluationStatus {
  Accepted = 'ACCEPTED',
  Incomplete = 'INCOMPLETE',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED'
}

export type RefundItem = {
  __typename?: 'RefundItem';
  id: Scalars['String']['output'];
  refundedQuantity: Scalars['Int']['output'];
};

export enum RefundItemEvaluationStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export enum RefundItemRejectedReasons {
  Damaged = 'DAMAGED',
  Expired = 'EXPIRED',
  ItemMissing = 'ITEM_MISSING',
  NotReturnable = 'NOT_RETURNABLE',
  SignsUse = 'SIGNS_USE',
  WrongItem = 'WRONG_ITEM'
}

export type RefundItemStatus = EvaluationAccepted | EvaluationRefused;

export type RefundReturnExtra = {
  __typename?: 'RefundReturnExtra';
  total?: Maybe<Price>;
  type: ExtrasDiscrepancyType;
};

export enum RefundStatusV2 {
  Accepted = 'ACCEPTED',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED'
}

export type RefundTransaction = {
  __typename?: 'RefundTransaction';
  externalRefundId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  origin: RefundTransactionOrigin;
  originalCreationDate: Scalars['AWSDateTime']['output'];
  parentType: RefundTransactionParentType;
  transactionTotal?: Maybe<Price>;
  type: RefundTransactionType;
};

export enum RefundTransactionOrigin {
  Manual = 'MANUAL',
  Shopify = 'SHOPIFY'
}

export enum RefundTransactionParentType {
  Order = 'ORDER',
  Return = 'RETURN'
}

export enum RefundTransactionType {
  Credit = 'CREDIT',
  Traditional = 'TRADITIONAL'
}

export enum RefundType {
  Credit = 'CREDIT',
  Traditional = 'TRADITIONAL'
}

export type RefundUnit = {
  __typename?: 'RefundUnit';
  description?: Maybe<Scalars['String']['output']>;
  finance?: Maybe<FinanceUnit>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Price>;
  price?: Maybe<Price>;
  qa?: Maybe<QaUnit>;
  reason: ReturnReasons;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  refundId: Scalars['ID']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  totalQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type RefundUnitInput = {
  finance?: InputMaybe<FinanceUnitInput>;
  id: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  refundId: Scalars['ID']['input'];
};

export type RefundUnitsInput = {
  units?: InputMaybe<Array<RefundUnitInput>>;
};

export type RejectRefundInput = {
  additions?: InputMaybe<Array<UpdateRefundExtrasInput>>;
  deductions?: InputMaybe<Array<UpdateRefundExtrasInput>>;
  id: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type Result = {
  __typename?: 'Result';
  result: Scalars['Boolean']['output'];
};

export type Return = {
  __typename?: 'Return';
  accountEmail: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdByMerchant?: Maybe<Scalars['Boolean']['output']>;
  exchanges?: Maybe<Array<Exchanges>>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  hasShipment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  items: Array<ReturnItems>;
  merchant: Merchant;
  name?: Maybe<Scalars['String']['output']>;
  order: ReturnOrderDetail;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Payment>;
  refundV2?: Maybe<Refund>;
  shipment?: Maybe<Shipment>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  userProvidedOrderId?: Maybe<Scalars['String']['output']>;
  wishes?: Maybe<Array<Wish>>;
};

export enum ReturnCostsPaymentType {
  DeductRefund = 'DEDUCT_REFUND',
  Upfront = 'UPFRONT'
}

export type ReturnDraftDeliveryDetailsFromInput = {
  address: SimpleAddressInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ReturnDraftDeliveryDetailsInput = {
  carrier: DeliveryDetailsCarrierInput;
  dimensions?: InputMaybe<DimensionsInput>;
  from: ReturnDraftDeliveryDetailsFromInput;
  weight?: InputMaybe<WeightsInput>;
};

export type ReturnDraftItemsInput = {
  itemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reason: ReturnReasons;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  reasonId: Scalars['String']['input'];
};

export type ReturnDraftRefundInput = {
  type: RefundType;
};

export type ReturnItems = {
  __typename?: 'ReturnItems';
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated User discountPerUnit */
  discount?: Maybe<Price>;
  discountPerUnit?: Maybe<Price>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paidPerUnit?: Maybe<Price>;
  /** @deprecated Use pricePerUnit */
  price?: Maybe<Price>;
  pricePerUnit?: Maybe<Price>;
  quantity: Scalars['Int']['output'];
  reason: ReturnReasons;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use weightPerUnit */
  weight?: Maybe<Scalars['Float']['output']>;
  weightPerUnit?: Maybe<Weight>;
};

export type ReturnLabelOnlyItemInput = {
  quantity: Scalars['Int']['input'];
  reason: ReturnReasons;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  reasonId: Scalars['String']['input'];
};

export type ReturnOrderDetail = {
  __typename?: 'ReturnOrderDetail';
  externalOrderId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  type: ReturnOrderType;
  userProvidedOrderId?: Maybe<Scalars['String']['output']>;
};

export enum ReturnOrderType {
  LabelOnly = 'LABEL_ONLY',
  Order = 'ORDER'
}

export enum ReturnReasons {
  AccidentalPurchase = 'ACCIDENTAL_PURCHASE',
  ArrivedLate = 'ARRIVED_LATE',
  ChangedMind = 'CHANGED_MIND',
  Damaged = 'DAMAGED',
  DifferentDescription = 'DIFFERENT_DESCRIPTION',
  DifferentImage = 'DIFFERENT_IMAGE',
  IncorrectItem = 'INCORRECT_ITEM',
  Other = 'OTHER',
  PoorQuality = 'POOR_QUALITY',
  Recycle = 'RECYCLE',
  RepairOrReplacement = 'REPAIR_OR_REPLACEMENT',
  TooExpensive = 'TOO_EXPENSIVE',
  TooLarge = 'TOO_LARGE',
  TooSmall = 'TOO_SMALL'
}

export enum ReturnState {
  Complete = 'COMPLETE',
  Fail = 'FAIL',
  Processing = 'PROCESSING'
}

export type ReturnsPage = {
  __typename?: 'ReturnsPage';
  query: Scalars['String']['output'];
  results: Array<BrandReturn>;
  total: Scalars['Int']['output'];
};

export type RoyalMailDetails = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  dcAuthCompany: Scalars['String']['input'];
  integration: RoyalMailIntegrationType;
  locationId: Scalars['String']['input'];
};

export enum RoyalMailIntegrationType {
  DespatchCloud = 'DESPATCH_CLOUD',
  Sapient = 'SAPIENT'
}

export type SelectedOption = {
  __typename?: 'SelectedOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ServerEvent = {
  __typename?: 'ServerEvent';
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type ServerEventInput = {
  eventName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum ServiceConstraintType {
  Country = 'COUNTRY',
  Size = 'SIZE',
  TimeSlot = 'TIME_SLOT',
  Weight = 'WEIGHT'
}

export type Shipment = {
  __typename?: 'Shipment';
  carrier: ShipmentCarrier;
  collection?: Maybe<ShipmentCollection>;
  collectionId?: Maybe<Scalars['String']['output']>;
  collectionRequestedTimeSlot?: Maybe<TimeSlot>;
  collectionState?: Maybe<DeliveryState>;
  deliveryState?: Maybe<DeliveryState>;
  events?: Maybe<Array<DeliveryEvents>>;
  failureReason?: Maybe<Scalars['String']['output']>;
  from: DeliveryAddress;
  id: Scalars['ID']['output'];
  labels?: Maybe<Array<Label>>;
  latestDeliveryEvent?: Maybe<DeliveryEventType>;
  merchantId?: Maybe<Scalars['ID']['output']>;
  parcels: Array<ShipmentParcel>;
  state: DeliveryState;
  to: DeliveryAddress;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ShipmentCarrier = {
  __typename?: 'ShipmentCarrier';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  labelExpireDays?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  service: ShipmentCarrierService;
  type: CarrierType;
};

export type ShipmentCarrierService = {
  __typename?: 'ShipmentCarrierService';
  countryConstraint?: Maybe<CountryConstraint>;
  id: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
  isPrintLabelRequired?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  sizeConstraints?: Maybe<Array<SizeConstraint>>;
  weightConstraint?: Maybe<WeightConstraint>;
};

export type ShipmentCollection = {
  __typename?: 'ShipmentCollection';
  bookedTimeSlot: TimeSlot;
  rebooked: Scalars['Boolean']['output'];
};

export type ShipmentDimensions = {
  __typename?: 'ShipmentDimensions';
  height: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  unit: Sizes;
  width: Scalars['Float']['output'];
};

export type ShipmentParcel = {
  __typename?: 'ShipmentParcel';
  dimensions: ShipmentDimensions;
  weight: ShipmentWeight;
};

export enum ShipmentType {
  Collection = 'COLLECTION',
  DropOff = 'DROP_OFF'
}

export type ShipmentWeight = {
  __typename?: 'ShipmentWeight';
  unit: Weights;
  value: Scalars['Float']['output'];
};

export type ShipmentsPage = {
  __typename?: 'ShipmentsPage';
  results: Array<Shipment>;
  total: Scalars['Int']['output'];
};

export enum ShippingLabelName {
  Order = 'ORDER',
  Return = 'RETURN'
}

export type SimpleAddress = {
  __typename?: 'SimpleAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  postCode: Scalars['String']['output'];
};

export type SimpleAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  postCode: Scalars['String']['input'];
  provinceCode?: InputMaybe<Scalars['String']['input']>;
};

export type SizeConstraint = {
  __typename?: 'SizeConstraint';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  name: SizeConstraintName;
  type: ServiceConstraintType;
  unit: Sizes;
};

export type SizeConstraintInput = {
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  name: SizeConstraintName;
  unit: Sizes;
};

export enum SizeConstraintName {
  Height = 'HEIGHT',
  Length = 'LENGTH',
  Volume = 'VOLUME',
  Width = 'WIDTH'
}

export enum Sizes {
  Cm = 'CM'
}

export type Subscription = {
  __typename?: 'Subscription';
  onServerEvent?: Maybe<ServerEvent>;
};


export type SubscriptionOnServerEventArgs = {
  userId: Scalars['String']['input'];
};

export enum SupportedChannels {
  BigCommerce = 'BIG_COMMERCE',
  Magento = 'MAGENTO',
  WooCommerce = 'WOO_COMMERCE'
}

export type TimeSlot = {
  __typename?: 'TimeSlot';
  date: Scalars['String']['output'];
  time?: Maybe<Scalars['String']['output']>;
};

export type TimeSlotAdminCreateReturnInput = {
  sendEmail: Scalars['Boolean']['input'];
  timeSlot?: InputMaybe<TimeSlotInput>;
};

export type TimeSlotConstraintExcludeInput = {
  date: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
};

export type TimeSlotConstraintInput = {
  daySlots: Array<InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>>;
  exclude?: InputMaybe<Array<TimeSlotConstraintExcludeInput>>;
  lead?: InputMaybe<TimeSlotConstraintLeadInput>;
};

export type TimeSlotConstraintLeadInput = {
  days: Scalars['Int']['input'];
};

export type TimeSlotInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  createdAt: Scalars['AWSDateTime']['output'];
  currency: Scalars['String']['output'];
  iAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  type: TransactionType;
};

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type UpdateCarrierInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  dropOffPointEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dropOffPointExternalUrl?: InputMaybe<Scalars['String']['input']>;
  labelExpireDays?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parcelHub?: InputMaybe<ParcelHubContractDetailsInput>;
};

export type UpdateCarrierServicesInput = {
  collectionDependency?: InputMaybe<CollectionDependencies>;
  collectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  countryConstraint?: InputMaybe<CountryConstraintInput>;
  deliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryEstimate?: InputMaybe<DeliveryEstimateInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalType?: InputMaybe<ExternalCarrierType>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  isPrintLabelRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parcelHub?: InputMaybe<ParcelHubServiceConfig>;
  serviceId: Scalars['String']['input'];
  sizeConstraint?: InputMaybe<Array<SizeConstraintInput>>;
  timeSlotConstraint?: InputMaybe<TimeSlotConstraintInput>;
  weightConstraint?: InputMaybe<WeightConstraintInput>;
};

export type UpdateMerchantV2Input = {
  address?: InputMaybe<MerchantAddressInput>;
  backgroundImageUrl?: InputMaybe<Scalars['String']['input']>;
  colorScheme?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactWebsite?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<MerchantCreditInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<MerchantEmailSettingsInput>;
  estimatedShippingTime?: InputMaybe<Scalars['Int']['input']>;
  exclusions?: InputMaybe<MerchantExclusionsInput>;
  externalBillingReference?: InputMaybe<Scalars['String']['input']>;
  flexBrandId?: InputMaybe<Scalars['String']['input']>;
  gradingType?: InputMaybe<MerchantGradingType>;
  labelNamePreference?: InputMaybe<ShippingLabelName>;
  labelOnlyReturnEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logos?: InputMaybe<MerchantLogosInput>;
  manualReferenceCopy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderImportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<MerchantOrdersInput>;
  parcelHub?: InputMaybe<ParcelHubUpdateInput>;
  payments?: InputMaybe<MerchantPaymentInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  portalActive?: InputMaybe<Scalars['Boolean']['input']>;
  refundDayRange?: InputMaybe<Array<Scalars['Int']['input']>>;
  refunds?: InputMaybe<MerchantRefundsInput>;
  returnDeadline?: InputMaybe<Scalars['Int']['input']>;
  returnPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  weightUnits?: InputMaybe<Weights>;
};

export type UpdateRefundExtrasInput = {
  total?: InputMaybe<PriceInput>;
  type: ExtrasDiscrepancyType;
};

export type UpdateUserInput = {
  address?: InputMaybe<UserAddressInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  preferredUserName?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  addresses?: Maybe<Array<UserAddress>>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mainAddressId?: Maybe<Scalars['ID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  preferredUserName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserAddress = {
  __typename?: 'UserAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  nickname: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UserAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  nickname: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
};

export type Variant = {
  __typename?: 'Variant';
  externalId: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Scalars['Int']['output']>;
  optionsKey: Scalars['String']['output'];
  price: Price;
  selectedOptions: Array<SelectedOption>;
  sku?: Maybe<Scalars['String']['output']>;
};

export enum WaiveStatus {
  NotApplicable = 'NOT_APPLICABLE',
  NotWaived = 'NOT_WAIVED',
  Waived = 'WAIVED'
}

export type WaivedReasons = {
  __typename?: 'WaivedReasons';
  quantity: Scalars['Int']['output'];
  reason: ReturnReasons;
};

export type Wallet = {
  __typename?: 'Wallet';
  createdAt: Scalars['AWSDateTime']['output'];
  currency: Scalars['String']['output'];
  iCurrentBalance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  merchant?: Maybe<Merchant>;
  transactions?: Maybe<PaginatedTransactions>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type WalletTransactionsArgs = {
  pagination?: InputMaybe<PaginatedInput>;
};

export type Weight = {
  __typename?: 'Weight';
  unit: Weights;
  value: Scalars['Float']['output'];
};

export type WeightConstraint = {
  __typename?: 'WeightConstraint';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  type: ServiceConstraintType;
  unit: Weights;
};

export type WeightConstraintInput = {
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  unit: Weights;
};

export enum Weights {
  Grams = 'GRAMS',
  Kilograms = 'KILOGRAMS',
  Ounces = 'OUNCES',
  Pounds = 'POUNDS'
}

export type WeightsInput = {
  unit: Weights;
  value: Scalars['Float']['input'];
};

export type Wish = Exchange;

export type WishInput = {
  newProducts?: InputMaybe<Array<WishNewProductInput>>;
};

export type WishNewProductInput = {
  quantity: Scalars['Int']['input'];
  variantId: Scalars['ID']['input'];
};

export enum WishType {
  Exchange = 'EXCHANGE'
}

export type YodelAuthDetails = {
  contractId: Scalars['String']['input'];
  dcAuthCompany: Scalars['String']['input'];
};

export type EmailReturnMutationVariables = Exact<{
  returnId: Scalars['ID']['input'];
}>;


export type EmailReturnMutation = { __typename?: 'Mutation', emailReturn: { __typename?: 'Result', result: boolean } };

export type CreateC2CPaymentMutationVariables = Exact<{
  data: CreateC2CPaymentInput;
}>;


export type CreateC2CPaymentMutation = { __typename?: 'Mutation', paymentsC2CShipmentCreate: { __typename?: 'C2CPaymentResult', paymentIntent: string, customerSession?: string | undefined, id: string, total: { __typename?: 'Price', currency: string, value: number } } };

export type UpdateProfileMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'User', userId: string, firstName?: string | undefined, lastName?: string | undefined } };

export type GetMerchantCarriersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMerchantCarriersQuery = { __typename?: 'Query', merchant?: { __typename?: 'Merchant', id: string, name: string, carriers?: Array<{ __typename?: 'Carrier', id: string, name: string, logo?: string | undefined, services: Array<{ __typename?: 'CarrierService', id: string, name: string, isPrintLabelRequired?: boolean | undefined, collectionEnabled?: boolean | undefined, fees?: { __typename?: 'MerchantCarrierFees', price: { __typename?: 'Price', value: number, currency: string } } | undefined, constraints: Array<{ __typename: 'CountryConstraint', type: ServiceConstraintType, exclude?: Array<string> | undefined, include: Array<string> } | { __typename: 'SizeConstraint', type: ServiceConstraintType, name: SizeConstraintName, min: number, max: number, sUnit: Sizes } | { __typename: 'WeightConstraint', type: ServiceConstraintType, max: number, min: number, wUnit: Weights }> }> }> | undefined } | undefined };

export type ListShipmentsQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListShipmentsQuery = { __typename?: 'Query', returns: { __typename?: 'PaginatedReturns', nextToken?: string | undefined, results: Array<{ __typename?: 'Return', id: string, name?: string | undefined, createdAt: Date, shipment?: { __typename?: 'Shipment', deliveryState?: DeliveryState | undefined, carrier: { __typename?: 'ShipmentCarrier', name: string, logo?: string | undefined } } | undefined }> } };

export type GetShipmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
}>;


export type GetShipmentQuery = { __typename?: 'Query', return?: { __typename?: 'Return', id: string, name?: string | undefined, createdAt: Date, shipment?: { __typename?: 'Shipment', deliveryState?: DeliveryState | undefined, failureReason?: string | undefined, latestDeliveryEvent?: DeliveryEventType | undefined, state: DeliveryState, trackingNumber?: string | undefined, trackingUrl?: string | undefined, carrier: { __typename?: 'ShipmentCarrier', name: string, logo?: string | undefined, type: CarrierType, labelExpireDays?: number | undefined, service: { __typename?: 'ShipmentCarrierService', isPrintLabelRequired?: boolean | undefined, name: string, sizeConstraints?: Array<{ __typename: 'SizeConstraint', type: ServiceConstraintType, name: SizeConstraintName, min: number, max: number, sUnit: Sizes }> | undefined, weightConstraint?: { __typename: 'WeightConstraint', type: ServiceConstraintType, max: number, min: number, wUnit: Weights } | undefined } }, events?: Array<{ __typename?: 'DeliveryEvents', description?: string | undefined, type: DeliveryEventType, eventDate: Date }> | undefined, from: { __typename?: 'DeliveryAddress', email?: string | undefined, name: string, address?: { __typename?: 'SimpleAddress', city: string, line1: string, country: string, line2?: string | undefined, line3?: string | undefined, postCode: string } | undefined }, labels?: Array<{ __typename?: 'Label', type: LabelType, url: string }> | undefined, to: { __typename?: 'DeliveryAddress', phoneNumber?: string | undefined, name: string, email?: string | undefined, address?: { __typename?: 'SimpleAddress', city: string, country: string, line1: string, line2?: string | undefined, line3?: string | undefined, postCode: string } | undefined }, parcels: Array<{ __typename?: 'ShipmentParcel', dimensions: { __typename?: 'ShipmentDimensions', height: number, length: number, width: number, unit: Sizes } }> } | undefined, payment?: { __typename?: 'Payment', receiptUrl?: string | undefined, total?: { __typename?: 'Price', value: number, currency: string } | undefined } | undefined, items: Array<{ __typename?: 'ReturnItems', itemId: string, name?: string | undefined, quantity: number, description?: string | undefined, weightPerUnit?: { __typename?: 'Weight', value: number, unit: Weights } | undefined, paidPerUnit?: { __typename?: 'Price', value: number, currency: string } | undefined }> } | undefined };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', userId: string, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined };


export const EmailReturnDocument = gql`
    mutation EmailReturn($returnId: ID!) {
  emailReturn(returnId: $returnId) {
    result
  }
}
    `;
export type EmailReturnMutationFn = Apollo.MutationFunction<EmailReturnMutation, EmailReturnMutationVariables>;

/**
 * __useEmailReturnMutation__
 *
 * To run a mutation, you first call `useEmailReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailReturnMutation, { data, loading, error }] = useEmailReturnMutation({
 *   variables: {
 *      returnId: // value for 'returnId'
 *   },
 * });
 */
export function useEmailReturnMutation(baseOptions?: Apollo.MutationHookOptions<EmailReturnMutation, EmailReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailReturnMutation, EmailReturnMutationVariables>(EmailReturnDocument, options);
      }
export type EmailReturnMutationHookResult = ReturnType<typeof useEmailReturnMutation>;
export type EmailReturnMutationResult = Apollo.MutationResult<EmailReturnMutation>;
export type EmailReturnMutationOptions = Apollo.BaseMutationOptions<EmailReturnMutation, EmailReturnMutationVariables>;
export const CreateC2CPaymentDocument = gql`
    mutation CreateC2CPayment($data: CreateC2CPaymentInput!) {
  paymentsC2CShipmentCreate(data: $data) {
    paymentIntent
    customerSession
    id
    total {
      currency
      value
    }
  }
}
    `;
export type CreateC2CPaymentMutationFn = Apollo.MutationFunction<CreateC2CPaymentMutation, CreateC2CPaymentMutationVariables>;

/**
 * __useCreateC2CPaymentMutation__
 *
 * To run a mutation, you first call `useCreateC2CPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateC2CPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createC2CPaymentMutation, { data, loading, error }] = useCreateC2CPaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateC2CPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateC2CPaymentMutation, CreateC2CPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateC2CPaymentMutation, CreateC2CPaymentMutationVariables>(CreateC2CPaymentDocument, options);
      }
export type CreateC2CPaymentMutationHookResult = ReturnType<typeof useCreateC2CPaymentMutation>;
export type CreateC2CPaymentMutationResult = Apollo.MutationResult<CreateC2CPaymentMutation>;
export type CreateC2CPaymentMutationOptions = Apollo.BaseMutationOptions<CreateC2CPaymentMutation, CreateC2CPaymentMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($data: UpdateUserInput!) {
  updateProfile(data: $data) {
    userId
    firstName
    lastName
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const GetMerchantCarriersDocument = gql`
    query GetMerchantCarriers($id: ID!) {
  merchant(id: $id) {
    id
    name
    carriers {
      id
      name
      logo
      services {
        id
        name
        fees {
          price {
            value
            currency
          }
        }
        isPrintLabelRequired
        collectionEnabled
        constraints {
          ... on WeightConstraint {
            __typename
            type
            wUnit: unit
            max
            min
          }
          ... on SizeConstraint {
            __typename
            type
            sUnit: unit
            name
            min
            max
          }
          ... on CountryConstraint {
            __typename
            type
            exclude
            include
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMerchantCarriersQuery__
 *
 * To run a query within a React component, call `useGetMerchantCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMerchantCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMerchantCarriersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMerchantCarriersQuery(baseOptions: Apollo.QueryHookOptions<GetMerchantCarriersQuery, GetMerchantCarriersQueryVariables> & ({ variables: GetMerchantCarriersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMerchantCarriersQuery, GetMerchantCarriersQueryVariables>(GetMerchantCarriersDocument, options);
      }
export function useGetMerchantCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMerchantCarriersQuery, GetMerchantCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMerchantCarriersQuery, GetMerchantCarriersQueryVariables>(GetMerchantCarriersDocument, options);
        }
export function useGetMerchantCarriersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMerchantCarriersQuery, GetMerchantCarriersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMerchantCarriersQuery, GetMerchantCarriersQueryVariables>(GetMerchantCarriersDocument, options);
        }
export type GetMerchantCarriersQueryHookResult = ReturnType<typeof useGetMerchantCarriersQuery>;
export type GetMerchantCarriersLazyQueryHookResult = ReturnType<typeof useGetMerchantCarriersLazyQuery>;
export type GetMerchantCarriersSuspenseQueryHookResult = ReturnType<typeof useGetMerchantCarriersSuspenseQuery>;
export type GetMerchantCarriersQueryResult = Apollo.QueryResult<GetMerchantCarriersQuery, GetMerchantCarriersQueryVariables>;
export const ListShipmentsDocument = gql`
    query ListShipments($merchantId: ID, $count: Int, $nextToken: String) {
  returns(
    merchantId: $merchantId
    pagination: {count: $count, nextToken: $nextToken}
  ) {
    nextToken
    results {
      id
      name
      shipment {
        deliveryState
        carrier {
          name
          logo
        }
      }
      createdAt
    }
  }
}
    `;

/**
 * __useListShipmentsQuery__
 *
 * To run a query within a React component, call `useListShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShipmentsQuery({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *      count: // value for 'count'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<ListShipmentsQuery, ListShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListShipmentsQuery, ListShipmentsQueryVariables>(ListShipmentsDocument, options);
      }
export function useListShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListShipmentsQuery, ListShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListShipmentsQuery, ListShipmentsQueryVariables>(ListShipmentsDocument, options);
        }
export function useListShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListShipmentsQuery, ListShipmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListShipmentsQuery, ListShipmentsQueryVariables>(ListShipmentsDocument, options);
        }
export type ListShipmentsQueryHookResult = ReturnType<typeof useListShipmentsQuery>;
export type ListShipmentsLazyQueryHookResult = ReturnType<typeof useListShipmentsLazyQuery>;
export type ListShipmentsSuspenseQueryHookResult = ReturnType<typeof useListShipmentsSuspenseQuery>;
export type ListShipmentsQueryResult = Apollo.QueryResult<ListShipmentsQuery, ListShipmentsQueryVariables>;
export const GetShipmentDocument = gql`
    query GetShipment($id: ID!, $merchantId: ID!) {
  return(id: $id, merchantId: $merchantId) {
    id
    name
    shipment {
      carrier {
        name
        logo
        type
        labelExpireDays
        service {
          isPrintLabelRequired
          name
          sizeConstraints {
            ... on SizeConstraint {
              __typename
              type
              sUnit: unit
              name
              min
              max
            }
          }
          weightConstraint {
            ... on WeightConstraint {
              __typename
              type
              wUnit: unit
              max
              min
            }
          }
        }
      }
      deliveryState
      events {
        description
        type
        eventDate
      }
      failureReason
      from {
        email
        address {
          city
          line1
          country
          line2
          line3
          postCode
        }
        name
      }
      labels {
        type
        url
      }
      latestDeliveryEvent
      state
      to {
        phoneNumber
        name
        email
        address {
          city
          country
          line1
          line2
          line3
          postCode
        }
      }
      trackingNumber
      trackingUrl
      parcels {
        dimensions {
          height
          length
          width
          unit
        }
      }
    }
    payment {
      total {
        value
        currency
      }
      receiptUrl
    }
    items {
      itemId
      name
      quantity
      weightPerUnit {
        value
        unit
      }
      description
      paidPerUnit {
        value
        currency
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGetShipmentQuery__
 *
 * To run a query within a React component, call `useGetShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useGetShipmentQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables> & ({ variables: GetShipmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
      }
export function useGetShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
        }
export function useGetShipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
        }
export type GetShipmentQueryHookResult = ReturnType<typeof useGetShipmentQuery>;
export type GetShipmentLazyQueryHookResult = ReturnType<typeof useGetShipmentLazyQuery>;
export type GetShipmentSuspenseQueryHookResult = ReturnType<typeof useGetShipmentSuspenseQuery>;
export type GetShipmentQueryResult = Apollo.QueryResult<GetShipmentQuery, GetShipmentQueryVariables>;
export const GetUserDocument = gql`
    query GetUser {
  me {
    userId
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;